import { dateFormattedSlash } from 'util/dateHelper'

class InsuranceBroker {
    constructor(brokerId) {
        this.brokerId = brokerId
    }

    formatDate(createdAt) {
        this.createdAt = dateFormattedSlash(createdAt)
    }

    static fromJson({ createdAt, credentials }) {
        const insuranceBroker = new InsuranceBroker(credentials.brokerId)
        insuranceBroker.formatDate(createdAt)
        return insuranceBroker
    }
}

export default InsuranceBroker
